import { render } from "./router-link-null.vue?vue&type=template&id=29df84b9"
import script from "./router-link-null.vue?vue&type=script&lang=js"
export * from "./router-link-null.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__